import { createFileRoute } from '@tanstack/react-router';

import { queryProjectById } from '~/services/authorization/authorization.ts';

import { UserManagementGuideContent } from './-components/user-management-guide-content.tsx';

export const Route = createFileRoute('/(user-mgmt)/project/$project/user-mgmt-guide')({
  loader: async ({ context: { queryClient }, params: { project } }) => {
    return queryClient.ensureQueryData(queryProjectById(project));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { project } = Route.useParams();

  return (
    <UserManagementGuideContent
      scope="project"
      backLink={{ to: '/project/$project/user-mgmt/users', params: { project } }}
    />
  );
}
